import React, { useEffect, useMemo, useState } from "react"
import { Col, Row } from "reactstrap"
import axios from "axios"
import { useSelector } from "react-redux"
import configs from "../../../config"
const { Url, apiVersion } = configs.client
import Select from "react-select"
import DatePicker from "react-datepicker"
import ResetFiltersIcon from "components/Common/Icons/SettingIcons/ResetFiltersIcon"
import "react-datepicker/dist/react-datepicker.css"
import UnAuthorized from "store/auth/logout/UnAuthorized"
import UnAuthorizedPopup from "components/Common/UnAuthorized/UnAuthorizedPopup"
// import "react-select/dist/react-select.css"
import { useDispatch } from "react-redux"
import { unAuthUser } from "store/actions"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

export default function BroadcastreportsFilter({
  selectedTemplate,
  setSelectedTemplate,
  selectedUser,
  setSelectedUser,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  showAuthPopUp,
  setShowAuthPopUp,
}) {
  const [filters, setFilters] = useState({
    templates: [],
    users: [],
    startDate: null,
    endDate: null,
  })
  const { access, authorized } = useSelector(state => ({
    access: state.Login.userAccess,
    authorized: state.Login.authorized,
  }))

  const dispatch = useDispatch()

  //fetch template & user:
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [templatesResponse, usersResponse] = await Promise.all([
          axios.get(`${Url}/${apiVersion}/whatsapp-templates?status=approved`, {
            headers: { Authorization: `Bearer ${access}` },
          }),
          axios.get(`${Url}/${apiVersion}/users`, {
            headers: { Authorization: `Bearer ${access}` },
          }),
        ])
        const templates = templatesResponse.data.data.templates.map(
          template => ({
            value: template.name,
            label: template.name.replace(/_/g, " "),
          })
        )
        const users = usersResponse.data.data.users.map(user => ({
          value: user._id,
          label: `${user.firstName} ${user.lastName}`,
        }))
        setFilters(prevFilters => ({
          ...prevFilters,
          templates: templates,
          users: users,
        }))
      } catch (error) {
        if (error?.response?.status === 401) {
          dispatch(unAuthUser())
        } else {
          console.log(error)

          const errorMessage =
            error.response?.data?.message || "Failed to load filters."
          toast.error(errorMessage)
        }
      }
    }
    fetchData()
  }, [])

  //setDate
  const handleDateChange = dates => {
    const [start, end] = dates
    setStartDate(start)
    setEndDate(end)
  }

  //style react select
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "gray" : "white",
      backgroundColor: state.isFocused ? "#EBEDF0" : "white",
      color: state.isSelected ? "white" : "black",
      borderColor: state.isFocused ? "#ddd" : "#ddd",
      boxShadow: state.isFocused ? "none" : "",
    }),
    control: (provided, state) => ({
      ...provided,
      borderRadius: "0.5rem",
      padding: "0rem 1rem",
      // height: "3rem",
      minHeight: "3rem",
      maxHeight: "5rem",
      overflow: "auto",
      borderColor: state.isFocused ? "#ddd" : "#ddd",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #ddd",
      },

      boxShadow: state.isFocused ? "none" : "",
    }),
  }

  const handleResetFilters = () => {
    setSelectedTemplate([])
    setSelectedUser([])
    setStartDate(null)
    setEndDate(null)
  }

  if (!authorized) {
    return <UnAuthorizedPopup />
  }

  const isFiltered =
    selectedTemplate?.length > 0 ||
    selectedUser?.length > 0 ||
    startDate !== null ||
    endDate !== null

  return (
    <>
      <Row className="tt">
        {/* {showAuthPopUp && <AuthPopUp />} */}

        <Col>
          <Select
            className=" text-capitalize "
            options={filters.templates}
            value={selectedTemplate}
            onChange={setSelectedTemplate}
            placeholder="Template"
            isClearable={true}
            isMulti={true}
            styles={customStyles}
          />
        </Col>

        <Col>
          <Select
            className="text-capitalize"
            value={selectedUser}
            onChange={setSelectedUser}
            options={filters.users}
            placeholder="user"
            isClearable={true}
            isMulti={true}
            styles={customStyles}
          />
        </Col>

        <Col>
          <DatePicker
            className=" broadcast-filter-date-picker text-capital"
            selectsRange={true}
            dateFormat="yyyy/MM/dd"
            startDate={startDate}
            placeholderText=" Date "
            endDate={endDate}
            onChange={handleDateChange}
            maxDate={new Date()}
            isClearable
            minDate={null}
          />
        </Col>
        {isFiltered && (
          <button
            onClick={handleResetFilters}
            className="border-0 bg-transparent  d-flex justify-content-around align-items-center reset-filters-report"
          >
            <ResetFiltersIcon />
          </button>
        )}
      </Row>
    </>
  )
}
